<template>
  <main class="bonus-points">
    <span>offer for customer</span>
    <input type="text" class="item-name-input" :value="payload.item_name" @change="changedForCustomer" data-cy="bonus-point-name-input"/>

    <span>bonus type</span>
    <div class="tab-container">
      <div @click="clickedBonusType('add')" class="tab" :class="{ selected: payload.bonus_type === 'add' }" data-cy="bonus-point-add-button">
        <span>+</span>
        <span>add</span>
      </div>

      <div @click="clickedBonusType('multiply')" class="tab" :class="{ selected: payload.bonus_type === 'multiply' }" data-cy="bonus-point-multiply-button">
        <span>x</span>
        <span>multiply</span>
      </div>
    </div>

    <span>bonus value</span>
    <input type="number" class="item-name-input" :value="payload.bonus_value" @change="changedBonusValue" min="0" step="1" data-cy="bonus-point-bonus-value-input"/>

    <span>offer per customer</span>
    <select @change="changedPerCustomer" :value="payload.max_redemptions" class="per-customer-dropdown" data-cy="bonus-point-max-redemptions-select">
      <option value="-1">unlimited</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
      <option value="10">10</option>
    </select>

    <span>expiration date</span>
    <small>expires at 11:59 PM</small>
    <flat-pickr
      :value="payload.expiration_date"
      :config="flatPickerConfig"
      class="control-expiration"
      @on-close="changedExpiration"
      data-cy="bonus-points-expiration-date-input">
    </flat-pickr>

    <span>min purchase amount</span>
    <input type="number" class="min-purchase" :value="payload.min_purchase_amount" @change="changedMinAmount" placeholder="$0.00" min="0" step="0.1" data-cy="bonus-points-min-purchase-amount-input" />

    <section v-if="!loadingPreload">
      <div v-if="!preload" class="attachment-container">
        <a v-file-upload:png,gif,jpeg="changedPreload" style="margin-bottom:3px" data-cy="bonus-points-preload-image-button">preload image</a>
        <span>sends with your text</span>
      </div>

      <div v-if="preload" class="attachment-container">
        <span>preload image</span>
        <img :src="preload.thumb" />
        <span class="remove-btn" @click="clickedRemove" data-cy="bonus-points-preload-image-remove-button">remove</span>
      </div>
    </section>

    <loading-icon v-if="loadingPreload" />
  </main>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { format } from "date-fns";
import LoadingIcon from "../../shared/LoadingIcon";

export default {
  name: "bonus-points",
  components: {
    LoadingIcon,
    flatPickr
  },
  props: {
    payload: Object,
    preload: Object,
    loadingPreload: Boolean
  },
  data() {
    return {
      selectedTab: null,
      date: '',
      flatPickerConfig: {
        altFormat: "D, M j",
        altInput: true,
        altInputClass: 'flatpickr-input',
        dateFormat: 'Y-m-d',
        minDate: new Date()
      },
    }
  },
  methods: {
    changedForCustomer(event) {
      this.$emit('update:payload', { item_name: event.target.value });
    },
    clickedBonusType(type) {
      this.$emit('update:payload', { bonus_type: type });
    },
    changedBonusValue(event) {
      this.$emit('update:payload', { bonus_value: event.target.value });
    },
    changedPerCustomer(event) {
      this.$emit('update:payload', { max_redemptions: event.target.value });
    },
    changedExpiration(value) {
      this.$emit('update:payload', { expiration_date_local: format(value[0], 'Y-dd-MM') })
    },
    changedMinAmount(event) {
      this.$emit('update:payload', { min_purchase_amount: event.target.value })
    },
    changedPreload(file) {
      this.$emit('update:preload', file);
    },
    clickedRemove() {
      this.$emit('update:preload', null)
    }
  }
}
</script>

<style scoped>
.bonus-points, .attachment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.attachment-container {
  color: #4a4a4a;
  font-size: 14px;
  font-family: AileronThin;
}

.per-customer-dropdown {
  max-width: 100px;
}

.min-purchase {
  max-width: 90px;
}

.tab-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom:10px;
  width: 100%;
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  padding: 4px 10px;
  line-height: 1;
  border: 1px solid #128fff;
  cursor: pointer;
  font-family: 'AileronThin';
}

.tab span:last-of-type {
  color: #a4a4a4;
  font-size: 12.8px;
  margin-top: 2px;
}

.tab.selected {
  background-color: #128fff;
  color: white;
}

.tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.tab:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

img {
  height: 75px;
  border: 1px solid #128ff9;
}

.remove-btn {
  cursor: pointer;
}

.loading-icon {
  width: 50px;
}

input {
  width: 100%;
}
</style>
